enum MixingRoutes {
    MIXING = "mixing",
    USER = "mixingUser",
    SETTINGS = "mixingSettings",
    TABLETID = "mixingSettingsTabletId",
    BATCH = "mixingBatch",
}

export default MixingRoutes;
